import dateHelper from '@/utils/portuna/dateHelper';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {ROUTE_REF_PARAM_DEFINITION} from '../utils/portuna';

const TimeTrackerAssistantOutro   = () => import('../views/time-tracker/assistant/TimeTrackerAssistantOutro.vue');
const TimeTrackerAssistantIntro   = () => import('../views/time-tracker/assistant/TimeTrackerAssistantIntro.vue');
const TimeTrackerAssistant        = () => import('../views/time-tracker/assistant/TimeTrackerAssistant.vue');
const EvaluationList              = () => import('../views/time-tracker/evaluation/EvaluationList.vue');
const EvaluationView              = () => import('../views/time-tracker/evaluation/EvaluationView.vue');
const EvaluationEdit              = () => import('../views/time-tracker/evaluation/EvaluationEdit.vue');
const CorrectionList              = () => import('../views/time-tracker/correction/CorrectionList.vue');
const CorrectionLog               = () => import('../views/time-tracker/correction/CorrectionLog.vue');
const ViolationList               = () => import('../views/time-tracker/violation/ViolationList.vue');
const OvertimeList                = () => import('../views/time-tracker/overtime/OvertimeList.vue');
const OvertimeCreditList          = () => import('../views/time-tracker/overtime/OvertimeCreditList.vue');
const OvertimeRequestList         = () => import('../views/time-tracker/overtime/OvertimeRequestList.vue');
const OvertimeStartList           = () => import('../views/time-tracker/overtime/OvertimeStartList.vue');
const OvertimeStartImport         = () => import('../views/time-tracker/overtime/OvertimeStartImport.vue');
const ReductionList               = () => import('../views/time-tracker/reduction/ReductionList.vue');
const CoreTimeReductionList       = () => import('../views/time-tracker/reduction/CoreTimeReductionList.vue');
const ProjectList                 = () => import('../views/time-tracker/project/ProjectList.vue');
const ProjectEdit                 = () => import('../views/time-tracker/project/ProjectEdit.vue');
const ProjectView                 = () => import('../views/time-tracker/project/ProjectView.vue');
const SettingsEdit                = () => import('../views/time-tracker/settings/SettingsEdit.vue');
const SettingsView                = () => import('../views/time-tracker/settings/SettingsView.vue');
const PlanningList                = () => import('../views/time-tracker/planning/PlanningList.vue');
const PlanningView                = () => import('../views/time-tracker/planning/PlanningView.vue');
const LogList                     = () => import('../views/time-tracker/log/LogList.vue');
const TimeTrackerProjectStatistic = () => import('../views/time-tracker/project/statistic/TimeTrackerProjectStatistic.vue');

let timeTrackerMeta: MetaData = {
    module: 'employee',
    assistant: {
        key: 'time_tracker',
        steps: [
            {
                component: TimeTrackerAssistantIntro,
                id: 'timeTrackerAssistantIntro',
            },
            {
                title: 'Abwesenheiten und Zeiterfassung',
                titleIcon: 'support',
                component: TimeTrackerAssistant,
            },
            {
                component: TimeTrackerAssistantOutro,
                id: 'timeTrackerAssistantOutro',
            },
        ],
    },
};

let timeTracker: RouteRecordRaw[] = [
    {
        name: 'time-tracker',
        path: '/employee/time-tracker',
        redirect: {name: 'time-tracker-evaluation-default-list'},
    },
    {
        name: 'time-tracker-index',
        path: '/employee/time-tracker/index',
        redirect: {name: 'time-tracker-evaluation-default-list'},
    },

    //<editor-fold desc="Evaluation">
    {
        name: 'time-tracker-evaluation',
        path: '/employee/time-tracker/evaluation',
        redirect: {name: 'time-tracker-evaluation-default-list'},
    },
    {
        name: 'time-tracker-evaluation-default-list',
        path: '/employee/time-tracker/evaluation/list',
        component: EvaluationList,
        meta: timeTrackerMeta,
        props()
        {
            return {
                entity: 0,
                from: '',
                to: '',
            };
        },
    },
    {
        name: 'time-tracker-evaluation-list',
        path: '/employee/time-tracker/evaluation/list/:entity/:from/:to/:former?',
        component: EvaluationList,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                entity: parseInt(route.params.entity),
                from: route.params.from,
                to: route.params.to,
                former: parseInt(route.params.former) || 0,
            };
        },
    },
    {
        name: 'time-tracker-evaluation-view',
        path: '/employee/time-tracker/evaluation/view/:employee/:week/',
        component: EvaluationView,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                employee: parseInt(route.params.employee) || 0,
                week: route.params.week || '',
            };
        },
    },
    {
        name: 'time-tracker-evaluation-edit',
        path: '/employee/time-tracker/evaluation/edit/:employee/:week/',
        component: EvaluationEdit,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                employee: parseInt(route.params.employee) || 0,
                week: route.params.week || '',
            };
        },
    },
    //</editor-fold>
    //<editor-fold desc="Correction">
    {
        name: 'time-tracker-correction',
        path: '/employee/time-tracker/correction',
        redirect: {name: 'time-tracker-correction-list'},
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-correction-list',
        path: '/employee/time-tracker/correction/list',
        component: CorrectionList,
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-correction-log',
        path: '/employee/time-tracker/correction/log',
        component: CorrectionLog,
        meta: timeTrackerMeta,
    },
    //</editor-fold>
    //<editor-fold desc="Violation">
    {
        name: 'time-tracker-violation-list',
        path: '/employee/time-tracker/violation/list',
        component: ViolationList,
        meta: timeTrackerMeta,
    },
    //</editor-fold>
    //<editor-fold desc="Overtime">
    {
        name: 'time-tracker-overtime-list',
        path: '/employee/time-tracker/overtime/list/:employee(\\d+)?/entity/:entity(\\d+)?',
        alias: [
            '/employee/time-tracker/overtime/list/employeeId/:employee(\\d+)?/:entity(\\d+)?',
            '/employee/time-tracker/overtime/list/:employee(\\d+)?/:entity(\\d+)?',
        ],
        component: OvertimeList,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                employee: parseInt(route.params.employee) || 0,
                entity: parseInt(route.params.entity) || 0,
            };
        },
    },
    {
        name: 'time-tracker-overtime-credit-list',
        path: '/employee/time-tracker/overtime/credit-list',
        component: OvertimeCreditList,
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-overtime-request-list',
        path: '/employee/time-tracker/overtime/request-list',
        component: OvertimeRequestList,
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-overtime-start-list',
        path: '/employee/time-tracker/overtime/start-list',
        component: OvertimeStartList,
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-overtime-start-import',
        path: '/employee/time-tracker/overtime/start-import',
        component: OvertimeStartImport,
        meta: timeTrackerMeta,
    },
    //</editor-fold>
    //<editor-fold desc="Reduction">
    {
        name: 'time-tracker-reduction-list',
        path: '/employee/time-tracker/reduction/list',
        component: ReductionList,
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-core-time-reduction-list',
        path: '/employee/time-tracker/reduction/core-time-list',
        component: CoreTimeReductionList,
        meta: timeTrackerMeta,
    },
    //</editor-fold>
    //<editor-fold desc="Project">
    {
        name: 'time-tracker-project-list',
        path: '/employee/time-tracker/project',
        component: ProjectList,
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-project-add',
        path: '/employee/time-tracker/project/add/:track(track)?/' + ROUTE_REF_PARAM_DEFINITION,
        component: ProjectEdit,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: 0,
                mode: 'add',
                track: !!route.params.track,
            };
        },
    },
    {
        name: 'time-tracker-project-edit',
        path: '/employee/time-tracker/project/edit/:id(\\d+)',
        component: ProjectEdit,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                mode: 'edit',
            };
        },
    },
    {
        name: 'time-tracker-project-copy',
        path: '/employee/time-tracker/project/copy/:id(\\d+)',
        component: ProjectEdit,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                mode: 'copy',
            };
        },
    },
    {
        name: 'time-tracker-project-view',
        path: '/employee/time-tracker/project/view/:id(\\d+)',
        component: ProjectView,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'time-tracker-project-statistic-year',
        path: '/employee/statistic/project/year/:year?',
        component: TimeTrackerProjectStatistic,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: 'year',
                year: parseInt(route.params.year || <string>dateHelper('Y')),
            };
        },
    },
    {
        name: 'time-tracker-project-statistic-month-alias',
        path: '/employee/statistic/project/month',
        redirect: {
            name: 'time-tracker-project-statistic-month',
        },
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-project-statistic-month',
        path: '/employee/statistic/project/month/:month?/:year?',
        component: TimeTrackerProjectStatistic,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: 'month',
                year: parseInt(route.params.year || <string>dateHelper('Y')),
                month: parseInt(route.params.month || <string>dateHelper('m')),
            };
        },
    },
    {
        name: 'time-tracker-project-statistic-week-alias',
        path: '/employee/statistic/project/week',
        redirect: {
            name: 'time-tracker-project-statistic-week',
        },
        meta: timeTrackerMeta,
    },
    {
        name: 'time-tracker-project-statistic-week',
        path: '/employee/statistic/project/week/:week?/:year?',
        component: TimeTrackerProjectStatistic,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: 'week',
                year: parseInt(route.params.year || <string>dateHelper('Y')),
                week: parseInt(route.params.week || <string>dateHelper('W')),
            };
        },
    },
    //</editor-fold>
    //<editor-fold desc="Settings">
    {
        name: 'time-tracker-settings',
        path: '/employee/time-tracker/settings/view/:type?/:tab?/:mode(current|future)?',
        component: SettingsView,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: parseInt(route.params.type) || 0,
                tab: route.params.tab || '',
                mode: route.params.mode || 'current',
            };
        },
    },
    {
        name: 'time-tracker-settings-edit',
        path: '/employee/time-tracker/settings/edit/:type?/:entity?/:employee?/:tab?/:mode(current|future)?',
        component: SettingsEdit,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: parseInt(route.params.type) || 0,
                entity: parseInt(route.params.entity) || 0,
                employee: parseInt(route.params.employee) || 0,
                tab: route.params.tab || 'general',
                mode: route.params.mode || 'current',
            };
        },
    },
    //</editor-fold>
    //<editor-fold desc="Planning">
    {
        name: 'time-tracker-planning-list',
        path: '/employee/time-tracker/planning/list/:year?/:week?',
        alias: '/employee/time-tracker/planning/list/year?/:year?/week/:week?*',
        component: PlanningList,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: parseInt(route.params.year) || 0,
                week: parseInt(route.params.week) || 0,
            };
        },
    },
    {
        name: 'time-tracker-planning-view',
        path: '/employee/time-tracker/planning/view/:year?/:week?',
        component: PlanningView,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: parseInt(route.params.year) || 0,
                week: parseInt(route.params.week) || 0,
            };
        },
    },
    {
        name: 'time-tracker-log',
        path: '/employee/time-tracker/log/:year?/:month?',
        component: LogList,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: parseInt(route.params.year) || 0,
                month: parseInt(route.params.week) || 0,
            };
        },
    },
    //</editor-fold>
    // /employee/time-tracker/planning/view/year/2021/week/6
    // COMPATIBILITY: OLD PATHS
    {
        path: '/employee/time-tracker/evaluation/view/employee/:employee/from/:from/to/:to',
        redirect: {name: 'time-tracker-evaluation-view'},
    },
];

export {timeTrackerMeta};
export default timeTracker;
